<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-stamp`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M35 3a1 1 0 011 1v9a1 1 0 01-1 1h-4.5l-.75 6H45a1 1 0 011 1v15a1 1 0 01-1 1h-2v7a1 1 0 01-1 1H6a1 1 0 01-1-1v-7H3a1 1 0 01-1-1V21a1 1 0 011-1h15.249l-.75-6H13a1 1 0 01-1-1V4a1 1 0 011-1h22zm4 34H9v4h30v-4zM6 24h36v9H6v-9zm20.468-10h-4.937l.75 6h3.438l.749-6zM16 7h16v3H16V7z"/></svg>
</template>
<script>

export default {
  name: 'IconStamp',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
